import React from 'react'
import { ButtonIconSeeker } from '@ui-seeker/core'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'


export default function ReportsHandlerSelectToolbar({selectedData, setSelectedRows}) {


	return <ButtonIconSeeker
			icon='people-arrows'
			onClick={() => {
				setSelectedRows([])
				isOpenReportsTransferModal.value = selectedData
			}}
			tooltip={'Transfer selected reports to another user'}
		/>
}